function getImageUrl() {
  return import.meta.env.VITE_IMAGE_URL;
}
export { getImageUrl };
